type MoveElementError = {
  startDateOutOfBoundProject: boolean;
  startDateOutOfBound: boolean;
  endDateOutOfBoundProject: boolean;
  endDateOutOfBound: boolean;
};

const moveElementError: MoveElementError = {
  startDateOutOfBoundProject: false,
  startDateOutOfBound: false,
  endDateOutOfBoundProject: false,
  endDateOutOfBound: false,
};

export type { MoveElementError };

export { moveElementError };
